import { memo } from 'react';
import type { IconProps } from './types';

const ErrorInfoIcon = ({ iconLabel, color }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            data-icon={iconLabel}
            color={color}
        >
            <g transform="translate(-174 -404)">
                <rect
                    fill="#e40038"
                    width="18"
                    height="18"
                    transform="translate(174 404)"
                />
                <text
                    className="b"
                    fill="#fff"
                    fontSize="11px"
                    fontFamily="Roboto, sans-serif"
                    fontWeight="500"
                    letterSpacing="0.08em"
                    transform="translate(182 417)"
                >
                    <tspan x="0" y="0">
                        !
                    </tspan>
                </text>
            </g>
        </svg>
    );
};

export default memo(ErrorInfoIcon);
